module.exports = __webpack_public_path__ + "img/kaihang.dc5ba131.jpg";